import { velocity } from 'src/js/lib/velocity.js';

export const fadeIn = async ( time ) => {
  const mainFrameElm = document.getElementById( 'ss-main-page' );
  await velocity( mainFrameElm, {
    props: {
      opacity: [ 1, 0 ],
    },
    opts: {
      delay: 300,
      duration: 400,
      easing: 'easeInOutSine',
    },
  });
  return new Promise ( resolve => {
    window.setTimeout( () => {
      resolve();
    }, time );
  });
}
